module.exports = __webpack_public_path__ + "static/media/conversion_3_blue.1712cee0.png";